export default __webpack_public_path__ + "static/media/spinner.dd769108.gif";